var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-slot"},[_c('img',{staticClass:"facestream-frame",attrs:{"src":_vm.prospData.data.camera.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }